import script from "./MainTemplateSegView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainTemplateSegView.vue?vue&type=script&setup=true&lang=ts"

import "./MainTemplateSegView.vue?vue&type=style&index=0&id=0d22e42d&lang=sass"
import "./MainTemplateSegView.vue?vue&type=style&index=1&id=0d22e42d&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d22e42d"]])

export default __exports__